import * as React from 'react';
import styled from 'styled-components';
import AngleRight from '../components/AngleRight';
import { Link } from 'gatsby';

const Article = styled.article`
	margin-bottom: 2em;
	border-radius: 0 0 10px 10px;
	box-shadow: 0px 10px 10px 5px rgba(0,0,0,0.1);

	@media (${(props) => props.theme.mediumUp}) {
		display: flex;
		flex-direction: column;
		margin-bottom: 1em;
		max-width: 572px;
		flex-basis: 50%;

		&:first-child {
			padding-right: 0;
			margin-right: 3em;
		}

		&:last-child {
			padding-left: 0;
			margin-left: 3em;
		}
	}

	/* ie11 fix */
	@media all and (-ms-high-contrast: none) {
		max-width: 500px;
	}

	& a {
		cursor: pointer;
	}

	& h2 {
		font-size: 21px;
		color: ${(props) => props.theme.lightBlue};
		text-transform: uppercase;
		margin-bottom: 1em;
	}

	& h3 {
		margin-bottom: 5px;
		font-size: 18px;
	}

	& .textWrapper {
		padding: 0 1em 2em 1.5em;

		& h2 {
			margin-left: -0.5em;
			margin-bottom: 0.5em;
		}

		@media (${(props) => props.theme.mediumUp}) {
			padding: 0 2em 2em 4em;

			& h2 {
				margin-left: -1.5em;
				margin-bottom: 1em;
			}
		}

		& h3 {
			max-width: 360px;
		}

		& p.oneLiner {
			font-size: 17px;
			margin-top: 1.3em;
		}
	}

	& figure {
		min-height: 200px;
		background-repeat: no-repeat;
		background-size: cover;
		margin-bottom: 1em;
		border-top: 8px solid ${(props) => props.theme.lightBlue};

		& a {
			display: block;
			height: 100%;
			width: 100%;
		}

		&.group {
			background-position: center 35%;
		}

		/* ie11 fix */
		@media all and (-ms-high-contrast: none) {
			max-width: 500px;
		}
	}
`;

const PortraitNameTitle = ({nonMKLink, url, backgroundImageURL, backgroundPosition, postCategory, postTitle, oneLiner}) => (
	<Article id='feed'>
		{nonMKLink ? (
			<>
				<a href={url} target='_blank' rel='noopener noreferrer'>
					<figure
						style={{backgroundImage: `url('${backgroundImageURL}')`,
						backgroundPosition: `center center`}}
					/>
				</a>
				<div className='textWrapper'>
					<h2>{postCategory}</h2>
					<h3>{postTitle}</h3>
					<p className='oneLiner'>{oneLiner}</p>
					<a href={url} className='readTheArticle animate-right' target='_blank' rel='noopener noreferrer'>
						Read the article <AngleRight smallMarginLeft={true} />
					</a>
				</div>
			</>
		) : (
			<>
				<a href={url}>
					<figure
						style={{backgroundImage: `url('${backgroundImageURL}')`,
						backgroundPosition: `${backgroundPosition}`}}
					/>
				</a>
				<div className='textWrapper'>
					<h2>{postCategory}</h2>
					<h3>{postTitle}</h3>
					<p className='oneLiner'>{oneLiner}</p>
					<a href={url} className='readTheArticle animate-right'>
						Read the story <AngleRight smallMarginLeft={true} />
					</a>
				</div>
			</>
		)}
	</Article>
);

export default PortraitNameTitle;
